<template>
  <b-dropdown class="user-menu" menu-class="w-100">
    <template #button-content>
      <div style="display: flex">
        <div class="avatar">
          {{ userData.username[0] }}
        </div>
        <div>
          <p v-if="userData.role" class="username">
            {{ ROLES_NAMES[userData.role] | i18n }}
          </p>
          <p v-if="userData.email || userData.username" class="email">
            {{ userData.email || userData.username }}
          </p>
        </div>
        <ArrowDownIcon class="arrow-icon" />
      </div>
    </template>
    <b-dropdown-item @click="showChangePasswordModal">
      <ChangePasswordIcon class="item-icon" />
      {{ 'Change password' | i18n }}
    </b-dropdown-item>
    <b-dropdown-item v-if="isSuperadmin" @click="showLicenseInfo">
      <InformationIcon class="item-icon" />
      {{ 'license_info' | i18n }}
    </b-dropdown-item>
    <b-dropdown-item v-if="isIIProject" target="_blank" :href="guidURL">
      <QuickStartGuideIcon class="item-icon" />
      {{ 'QuickStart Guide' | i18n }}
    </b-dropdown-item>
    <b-dropdown-item :href="isAVGProject ? 'mailto:support@sensis.de' : '#'" @click="showSupportModal">
      <SupportIcon class="item-icon" />
      {{ 'support' | i18n }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { ROLES_NAMES } from '../../../../constants';
import ArrowDownIcon from '../assets/icons/iconsCode/arrow-down';
import ChangePasswordIcon from '../assets/icons/iconsCode/change-password';
import InformationIcon from '../assets/icons/iconsCode/information';
import QuickStartGuideIcon from '../assets/icons/iconsCode/quick-start-guide';
import SupportIcon from '../assets/icons/iconsCode/support';
import { LicenseMixin, AuthMixin } from '../mixins';

export default {
  name: 'UserMenu',
  components: { ArrowDownIcon, ChangePasswordIcon, InformationIcon, QuickStartGuideIcon, SupportIcon },
  mixins: [LicenseMixin, AuthMixin],
  props: {
    userData: {
      type: Object,
      default: () => {},
    },
  },
  data: function() {
    return {
      ROLES_NAMES: ROLES_NAMES,
    };
  },
  computed: {
    guidURL() {
      let module = 'REPORTS';
      if (this.isDIGITAL35Project) {
        module = 'DIGITAL35';
      }
      const locate = this.lng.toUpperCase();
      return `https://deploy.cluster-one.eu/ii/reports/${module}_Admin_QuickStart_${locate}.pdf`;
    },
  },
  methods: {
    showLicenseInfo() {
      this.$root.$emit('bv::show::modal', 'licenseModal');
    },
    showChangePasswordModal() {
      this.$root.$emit('bv::show::modal', 'changePasswordModal');
    },
    showSupportModal() {
      if (this.isAVGProject) {
        return;
      }
      this.$root.$emit('bv::show::modal', 'supportModal');
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .dropdown-toggle {
  border-radius: 0;
  padding: 15px 30px 15px 20px;
  background-color: rgba(255,255,255,.4);
  border: none;
  box-shadow: -1px 0px 1px rgba(15, 32, 65, 0.04);
  &::after {
    display: none;
  }
}
::v-deep.show > .dropdown-toggle,
::v-deep .dropdown-toggle:not(:disabled):not(.disabled):active {
  border: none;
  background-color: rgba(255,255,255.0);
}
::v-deep .dropdown-menu {
  margin: 0;
  border: 0;
  border-top: 1px solid #f9f9fa;
  border-radius: 0 0 0 10px;
  box-shadow: -4px 10px 10px rgb(15 32 65 / 16%);
  > li:not(:last-child) {
    border-bottom: 1px solid #e9eeff;
  }
  .dropdown-item {
    padding: 10px 20px;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-transform: capitalize;
    color: #0F2041;
    .item-icon {
      width: 15px;
      margin-right: 5px;
      color: inherit;
    }
  }
  &.show {
    left: 5px!important;
  }
}
.avatar {
  background: rgba(34, 96, 255, 0.1);
  width: 34px;
  height: 34px;
  border-radius: 50%;
  margin-right: 8px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
}
.username,
.email {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #0F2041;
  text-align: left;
  margin-bottom: 0;
}
.email {
  color: #646A87;
}
.arrow-icon {
  color: #2260FF;
  width: 14px;
  margin-left: 30px;
}
</style>
